import Link from 'next/link'

import { LoadingButton } from '@mui/lab'
import { Button, Stack } from '@mui/material'

import { QuantityCounter } from '@/components/QuantityCounter/QuantityCounter'
import { getWebShopStatusVisibility } from '@/helpers/getWebShopStatusVisibility'
import { useIsLoggedIn } from '@/hooks/useIsLoggedIn'
import { useTranslations } from '@/hooks/useTranslations'

import type * as React from 'react'
import type { ProductProps } from '@/interfaces/product.interface'

interface Props {
  product: ProductProps
  quantity: number
  allowedQuantity: number
  onClick: VoidFunction
  isDisabled: boolean
  isLoading: boolean
  handleUpdateCounter: (value: number) => void
}

export const ProductDetailsBuyButton: React.FC<Props> = ({
  product,
  isDisabled,
  allowedQuantity,
  onClick,
  quantity,
  isLoading,
  handleUpdateCounter,
}) => {
  const { translate } = useTranslations()
  const isLoggedIn = useIsLoggedIn()

  const { shouldShowBuyButton } = getWebShopStatusVisibility(
    product?.productWebshopStatus,
    product?.productPartStatus,
    isLoggedIn
  )

  if (product.displayOnly || !shouldShowBuyButton) {
    return null
  }
  if (!product?.displayOnly) {
    return (
      <>
        <QuantityCounter value={quantity} updateCounter={handleUpdateCounter} max={allowedQuantity} />
        <LoadingButton
          variant="contained"
          size="medium"
          fullWidth
          onClick={onClick}
          disabled={isDisabled}
          loading={isLoading}
          sx={{ py: '14px' }}
        >
          <span>{translate(`productDetails.add`)}</span>
        </LoadingButton>
      </>
    )
  }

  return (
    <Stack direction="row" gap={2} flex={1}>
      <Link href={`/search?q=:relevance:productGroupCode:${product.nonInventoryParts?.[0].code}`}>
        <Button sx={{ mr: 2 }} variant="contained" size="medium" fullWidth>
          {!!product?.displayOnly && translate(`form.search.chooseAlternative`)}
        </Button>
      </Link>
    </Stack>
  )
}
